import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router'
import { append } from '../../../../utils/url'
import getThumbnail from '../../../util/getThumbnail'
import keyOn from './key_on'

import timeAgo from 'time_ago_in_words'

import AutoCompleteTags from '../../../util/auto_complete/Tags'
import AutoCompleteUsers from '../../../util/auto_complete/Users'
import Icon from '../../../util/Icon'

import api from '../../../../api'

import { formatDate, abbrNum, pluralize } from '../../../../utils/format'

import SocialContainer from '../../../social/SocialContainer'
import ListingsMap     from '../../../map'

import Notes from './Notes'

const verbs = {
  ViewedListing: 'viewed',
  HiddenListing: 'hid',
  SavedListing: 'saved',
  Reaction: 'reacted',
  Comment: 'commented',
  RecommendedListing: 'recommended',
  SavedSearch: 'Subscribed',
}

const reactions = [
  { shortname: 'rage', description: 'Hate it' },
  { shortname: 'slight_frown', description: 'Dislike it' },
  { shortname: 'neutral_face', description: 'Indifferent' },
  { shortname: 'smile', description: 'Like it' },
  { shortname: 'heart_eyes', description: 'Love it' }
]

const TagPill = ({ id, label, onRemove }) => (
  <div className="tag-pill">
    <span className="tag-label">{label}</span>
    <button type="button" onClick={() => onRemove(id)}>
      <Icon icon="times-circle" />
    </button>
  </div>
)

@keyOn('params.lead_id')
@inject('leads', 'users', 'websites')
@observer
export default class WebsiteLeadDetails extends Component {
  state = {
    tab: 'All',
    actions: null,
    fullyLoaded: false,
    hideTagInputarea: true,
    hideTagInputButton: false,

    // modals
    hideUpdateLeadModal:  true,
    hideEditLeadModal:    true,
    hideSmsOptInModal: true,

    // local lead state for modals
    leadStatus:     '',
    leadPersona:    '',
    leadFirstName:  '',
    leadLastName:   '',
    leadPhone:      '',
    leadEmail:      '',
  }

  tabs = {
    All: 'Recent Activity',
    ViewedListing: 'Listing Views',
    SavedListing: 'Saved Listings',
    SavedSearch: 'Search Subscriptions',
    Comment: 'Comments',
    Reaction: 'Reactions',
    HiddenListing: 'Hidden Listings',
  }

  getActionCount(action) {
    switch(action) {
      case 'Comment': return this.lead.comment_count
      case 'Reaction': return this.lead.reaction_count
      case 'ViewedListing': return this.lead.viewed_listing_count
      case 'SavedListing': return this.lead.saved_listing_count
      case 'Message': return this.lead.message_count
      case 'SavedSearch': return this.lead.saved_search_count
      case 'HiddenListing': return this.lead.hidden_listing_count
    }
  }

  componentDidMount() {
    this.fetchLead(this.props.params.lead_id).then(() => {
      this.getListingActions(this.state.tab)

      // This is a shim for us to manage the lead status & persona in local state
      // so our forums work properly. prior it was always a request made on change
      // but now it's behind a save button. we also kinda had a funky psudo state
      // by having this.lead
      this.setState({
        leadStatus:     this.lead.status,
        leadPersona:    this.lead.persona,
        leadFirstName:  this.lead.first_name,
        leadLastName:   this.lead.last_name,
        leadPhone:      this.lead.phone,
        leadEmail:      this.lead.email,
      })
    })
  }

  componentWillReceiveProps(nextProps) {
    const { lead_id: prevId } = this.props.params
    const { lead_id: nextId } = nextProps.params

    if (prevId !== nextId) {
      this.setState({ fullyLoaded: false })
      this.fetchLead(nextId)
    }
  }

  componentWillUpdate(_, nextState) {
    const { tab: prevTab } = this.state
    const { tab: nextTab } = nextState

    if (prevTab !== nextTab) this.getListingActions(nextTab)
  }

  fetchLead(id) {
    return this.props.leads.load(id).then(() => {
      this.setState({ fullyLoaded: true })
    })
  }

  getListingActions(action_type) {
    const { uuid: lead_uuid } = this.lead
    const { uuid: website_uuid } = this.website
    if (action_type === 'All') action_type = undefined
    const url = action_type === 'SavedSearch' ? 'lead_saved_searches' : 'listing_actions'
    const author_uuid = lead_uuid

    this.setState({ actions: null })
    api.get(url, { params: { website_uuid, lead_uuid, action_type, author_uuid} })
      .then(({ data: actions }) => this.setState({ actions }))
  }

  get lead() {
    return this._lead || (this._lead = this.props.leads.findById(this.props.params.lead_id))
  }

  get website() {
    return this.props.websites.current
  }

  resetLead = () => {
    // cleanup modal(s)
    this.setState({ hideUpdateLeadModal:  true,
                    hideEditLeadModal:    true,
                    hideSmsOptInModal: true,
                    leadPersona:          this.lead.persona,
                    leadStatus:           this.lead.status,
                    leadFirstName:        this.lead.first_name,
                    leadLastName:         this.lead.last_name,
                    leadPhone:            this.lead.phone,
                    leadEmail:            this.lead.email,
                  })
  }

  saveLead = () => {
    // updating this.lead with what we have in local state. not ideal but a stopgap for now
    this.lead.persona     = this.state.leadPersona
    this.lead.status      = this.state.leadStatus
    this.lead.first_name  = this.state.leadFirstName
    this.lead.last_name   = this.state.leadLastName
    this.lead.phone       = this.state.leadPhone
    this.lead.email       = this.state.leadEmail

    // make update call
    this.props.leads.update(this.lead)

    // cleanup modal(s)
    this.setState({hideUpdateLeadModal: true, hideEditLeadModal: true})
  }

  assignUser = (user) => {
    if (user) {
      this.props.leads.assignTo(this.props.params.lead_id, user.id)
    } else {
      this.props.leads.unassign(this.props.params.lead_id)
    }
  }

  addTag = (tag) => {
    this.props.leads.addTag(this.props.params.lead_id, tag.id)
  }

  removeTag = (lead_tag_id) => {
    this.props.leads.removeTag(this.props.params.lead_id, lead_tag_id)
  }

  fetchActionStyle(action) {
    let color = ''
    switch(action.action_type) {
      case 'ViewedListing': color = 'var(--green)';   break
      case 'SavedListing':  color = 'var(--orange)';  break
      case 'Comment':       color = 'var(--purple)';  break
      case 'Reaction':      color = 'var(--seafoam)'; break
      case 'HiddenListing': color = 'var(--red)';     break
      default:              color = 'grey'
    }
    return {borderLeft: `5px solid ${color}`}
  }

  fetchListingLink(action){
    const address = `${action._source.address}, ${action._source.city}, ${action._source.state}, ${action._source.zip}`
    if(action._source.close_date && new Date(action._source.close_date) < new Date(new Date().setFullYear(new Date().getFullYear() - 3))){
        return (
            <span style={{color: 'grey'}}>
              {address}
            </span>
        )
    }else {
      return (
          <a className="address" href={`${this.website.default_url}listing/${action.mls_id}/${action.mls_listing_id}`}
             target="_blank">
            {address}
          </a>
      )
    }
  }

  renderAction = action => {
    const { tab } = this.state

    if (tab === 'SavedSearch') {
      const getThumb = (params) => {
        const style = { margin: 0, width: "100px", height: "75px" }
        if (params !== undefined && params.map_center !== undefined && params.map_center.lon !== undefined && params.map_center.lat !== undefined) {
          const { map_center: { lon, lat } } = params
          const rootSrc = 'https://api.mapbox.com/styles/v1'
          const token = process.env.MAPBOX_ACCESS_TOKEN
          const mapStyle = this.website.settings.display.map_style
          let mapboxStaticImageUrl = [
            rootSrc,
            mapStyle,
            'static',
            `${lon},${lat},10`,
            `100x75?access_token=${token}`
          ].join('/')
          return (<img src={mapboxStaticImageUrl} style={style}/>)
        } else {
          return (<div style={style} />)
        }
      }
      return (
        <div key={`action-${action.id}`} className="action">
          {getThumb(action.params)}
          <div>
            <div className="activity">
              {this.lead.first_name || this.lead.email || "Lead"}
              {' '}
              Subscribed
              {' '}
              <span>- {timeAgo(new Date(action.created_at))}</span>
              {' '}
              <Link to={append(`edit-search/${action.id}`)}>Edit</Link>
            </div>
            <a className="address" href={`${this.website.default_url}search/${action.id}`} target="_blank">{action.title}</a>
            <div className="info" style={{textTransform: 'capitalize'}}>Email Frequency: {action.email_frequency}</div>
            <div className="info" style={{textTransform: 'capitalize'}}>Email Status: {this.lead.is_email_bounced ? 'Invalid Email' :  action.email_frequency === 'never' ? 'Unsubscribed' : 'Subscribed'}</div>
          </div>
        </div>
      )
    }
    if (!Object.keys(action._source).length) {
      return (
        <div key={`action-${action.id}`} className="action" style={{borderLeft: '5px solid var(--med-grey)'}}>
          <div>
            <div className="activity">
              {this.lead.first_name || this.lead.email || "Lead"}
              {' '}
              {verbs[action.action_type]}
              {action.action_type === 'Reaction' && ` with "${reactions[action.action.value].description}"`}
              {action.action_count && ` ${action.action_count} times`}
              {' '}
              <span>- {timeAgo(new Date(action.created_at))}</span>
            </div>
            <div className="info">This listing is no longer available.</div>
          </div>
        </div>
      )
    }
    return (
      <div key={`action-${action.id}`} className="action" style={this.fetchActionStyle(action)}>
        <img width="100" height="75" src={getThumbnail(action._source.image, '100x75')} />
        <div>
          <div className="activity">
            {this.lead.first_name || this.lead.email || "Lead"}
            {' '}
            {verbs[action.action_type]}
            {action.action_type === 'Reaction' && ` with "${reactions[action.action.value].description}"`}
            {action.action_count && ` ${action.action_count} times`}
            {' '}
            <span>- {timeAgo(new Date(action.created_at))}</span>
            {(verbs[action.action_type] == 'hid' || action.is_hidden) && <button className="successBadge">HIDDEN</button> }
          </div>

          {action.action_type === 'Comment' && (action.action.agent_visible ?
            <div className="comment">"{action.action.message}"</div> :
            <div className="comment private">Commented privately</div>)}


          {this.fetchListingLink(action)}

          <div className="info">
            {action._source.price && `$${abbrNum(action._source.price)}`}
            {' '}
            {action._source.bedrooms} {pluralize('bed', action._source.bedrooms)}
            {' '}
            {action._source.bathrooms} {pluralize('bath', action._source.bathrooms)}
            {' '}
            {action.mls_id.toUpperCase()}: {action.mls_listing_id}
          </div>
        </div>
      </div>
    )
  }

  renderRightColumn() {
    const { tab, actions } = this.state

    const verb = tab === 'All' ? 'Recent Activity' : this.tabs[tab]
    if (!actions) {
      return (
        <div className="loading">Loading {verb}...</div>
      )
    }
    else if (!actions.length) {
      return (
        <div className="loading">No {verb} For This Lead</div>
      )
    }
    else {
      return (
        <div>
          <div className="actions">
            {actions.map(this.renderAction)}
          </div>
        </div>
      )
    }
  }

  //////////////////////////////////////////////////////////////////////////////
  // New lead page stuff below
  //////////////////////////////////////////////////////////////////////////////

  handleChange(valueName, event) {
    this.setState({[valueName]: event.target.value})
  }

  render() {
    const { fullyLoaded } = this.state
    if (!fullyLoaded) {
      return (<div className="loading">Loading...</div>)
    }
    const { social } = this.lead.fullcontact
    const { actions } = this.state

    return (
      <div className='container lead'>
        <div className='leadLeftContainer'>
          { this.renderLeadInfo() }
          { this.renderSmsOptInStatus() }
          { this.renderContactStatus() }
          { this.renderMessageStatus() }
          { this.renderLeadStatusDates() }
          { this.renderLeadSocialProfile() }
          { this.renderLeadSavedSearchAction() }
          { this.renderAssignedTo() }
          { this.renderLeadActions() }
        </div>

        <div className='leadRightContainer'>
          <div className='innerContainer'>
            <div className='activityStatusBar'>
              { Object.entries(this.tabs).map(([type]) => this.renderTab(type)) }
            </div>
            <ListingsMap actions={actions} />
            <div className='innerContainerRow2'>
              <div className='feedColumn'>
                { this.renderRightColumn() }
              </div>
              <SocialContainer social={social} />
            </div>
          </div>
        </div>

        { this.renderUpdateLeadModal() }
        { this.renderEditLeadModal() }
        { this.renderSmsOptInModal() }
      </div>
    )
  }

  classesForTabs(context) {
    var classes = ['statusItem']
    if (context == this.state.tab) classes.push('statusItemSelected')
    return classes.join(' ')
  }

  renderTab(context = 'All') {
    return(
      <div key={context} className={this.classesForTabs(context)} onClick={() => this.setState({tab: context})}>
        <div className='statusItemContentContainer'>
          <div className='statusItemMetric'>{typeof this.getActionCount(context) === 'number' && this.getActionCount(context)}</div>
          <div className='statusItemLabel'>{this.tabs[context]}</div>
        </div>
      </div>
    )
  }

  renderSmsOptInStatus() {
    return(<div className='sms-opt-in-status-banner banner'>
      <span className='sms-opt-in-status-banner__left-icon'><Icon icon="comment" className="far fa-comment" /></span>
      {!this.lead.sms_opted_in_at && <span className='sms-opt-in-status-banner__message'>No SMS Opt in Detected</span>}
      {this.lead.sms_opted_in_at && <span className='sms-opt-in-status-banner__message'>SMS Opted in - {formatDate(this.lead.sms_opted_in_at)}</span>}
      <div className="sms-opt-in-status-banner__right-icon" onClick={() => this.setState({hideSmsOptInModal: false})}>
        <span className=''><Icon icon="question-circle" className="far fa-question-circle" /></span>
      </div>
    </div>)
  }

  renderContactStatus() {
    return(<div className='contactStatusContainer banner' onClick={() => this.setState({hideUpdateLeadModal: false})}>
      <span className='userIcon'><Icon icon="user" className="far fa-user" /></span>
      <span className='leadClassification'>{this.lead.persona} Lead: </span>
      <span className='contactStatus'>{this.lead.status}</span>
      <span className='editIcon'><Icon icon="edit" className="fa-edit" /></span>
    </div>)
  }

  renderMessageStatus() {
    return(
      <Link className='messageStatusContainer banner' to={`/website/${this.website.id}/messages?search=${this.lead.email}`}>
        <Icon icon="inbox" className="fas fa-inbox inboxIcon" />
        {+this.lead.message_count ? this.lead.message_count : 0} Messages
      </Link>
    )
  }

  renderLeadStatusDates() {
    return(
      <div className='leadStatusDates'>
        <div className='leadStatusDate'>
          <div className='leadStatusDateDate'>{formatDate(this.lead.created_at)}</div>
          <div className='minorContent'>First Seen</div>
        </div>
        <div className='leadStatusDate'>
          <div className='leadStatusDateDate'>{formatDate(this.lead.updated_at)}</div>
          <div className='minorContent'>Last Seen</div>
        </div>
      </div>
    )
  }

  renderLeadSocialProfile() {
    const { social } = this.lead.fullcontact
    if (social.length == 0) return null

    return(
      <div className='leadSocialProfile'>
        <div>Social Profile</div>
        <div>
          {social.map(({ type, url }) => (
            <a href={url} key={type} target="_blank">
              <img src={`/images/social/${type}.png`} />
            </a>
          ))}
        </div>
      </div>
    )
  }

  renderLeadSavedSearchAction() {
    return(
      <Link className='leadSavedSearchAction banner' to={`/website/${this.website.id}/recommended/searches/add/${this.lead.id}`}>
        <Icon icon="envelope" className="far fa-envelope" />
        &nbsp;
        New Saved Search Subscription
      </Link>
    )
  }

  renderLeadInfo() {
    const { photo } = this.lead.fullcontact
    const urlForPhoto = photo ? photo : "/images/missing_photo_avatar.png"

    return(<div className='leadContainer'>
      <div className='leadAvatar'><img src={urlForPhoto} /></div>
      <div className='leadName'>{this.lead.first_name} {this.lead.last_name}</div>
      <div className='leadPhone'>{this.lead.phone}</div>
      <div className='leadEmail'><a href={`mailto:${this.lead.email}`}>{this.lead.email}</a></div>
      <div className='leadEditActions minorLinks'>
        <span onClick={() => this.setState({hideEditLeadModal: false})}>edit</span>
      </div>
    </div>)
  }

  renderAssignedTo() {
    return(<div className='assignedToContainer'>
      <h1>Assigned to</h1>
      <AutoCompleteUsers onSelect={this.assignUser} selected={this.lead.assigned_to_id} />
    </div>)
  }

  renderLeadActions() {
    return(<div className='leadActionsContainer'>
      { this.renderFriendsAndFamily() }
      <hr />
      { this.renderTags() }
      <hr />
      <Notes
        leadNotes={this.lead.lead_notes.reverse()}
        leadId={this.props.params.lead_id}
        leads={this.props.leads}
        users={this.props.users}
      />
    </div>)
  }

  renderFriendsAndFamily() {
    return(<div className='friendsAndFamilyContainer'>
      <h1>Friends & Family</h1>
      {this.lead.search_party.map(({ id, name }) => (
        <Link to={`/website/${this.website.id}/leads/${id}`} key={id}>{name}</Link>
      ))}
      {this.lead.search_party.length ? null : (
        <span className='leadActionContent minorContent'>No Friends & Family Registered</span>
      )}
    </div>)
  }

  renderTags() {
    return(<div className='tagsContainer'>
      <h1>Tags</h1>
      <button className ='miniBadge'
              hidden    ={this.lead.lead_tags.length >= 1 || this.state.hideTagInputButton}
              onClick   ={() => this.setState({hideTagInputarea: false, hideTagInputButton: true})}>
        <Icon icon="fa-plus-circle" className="fas fa-plus-circle" /> Add
      </button>
      <div className="tags" hidden={this.lead.lead_tags.length <= 0 && this.state.hideTagInputarea}>
        <AutoCompleteTags
          clearAfterSelect
          onSelect={this.addTag}
          exclude={this.lead.lead_tags.map(t => t.tag_id)} />

        <div className="tag-pills">
          {this.lead.lead_tags.map(tag => (
            <TagPill key={tag.id} id={tag.id} label={tag.label} onRemove={this.removeTag} />
          ))}
        </div>
      </div>
    </div>)
  }

  renderUpdateLeadModal() {
    return( <div className='updateLeadModal' hidden={this.state.hideUpdateLeadModal}>
      <section className='modal-main'>
        <h1>Update Lead</h1>

        <h4>Persona</h4>
        <select value={this.state.leadPersona} onChange={this.handleChange.bind(this, 'leadPersona')}>
          <option value="Buyer">Buyer</option>
          <option value="Seller">Seller</option>
          <option value="Buyer/Seller">Buyer/Seller</option>
          <option value="Investor">Investor</option>
          <option value="Renter">Renter</option>
          <option value="Past Client">Past Client</option>
          <option value="Lender">Lender</option>
          <option value="Escrow">Escrow</option>
          <option value="Vendor">Vendor</option>
          <option value="Agent">Agent</option>
          <option value="Client">Client</option>
          <option value="Other">Other</option>
          <option value="Time Waster">Time Waster</option>
        </select>

        <h4>Status</h4>
        <select value={this.state.leadStatus} onChange={this.handleChange.bind(this, 'leadStatus')}>
          <option value="New">New</option>
          <option value="Contacted">Contacted</option>
          <option value="Attempted Contact">Attempted Contact</option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
          <option value="Dead">Dead</option>
          <option value="Closed Deal">Closed Deal</option>
          <option value="Future">Future</option>
          <option value="Past Client">Past Client</option>
          <option value="Non Client">Non Client</option>
        </select>

        <button className="confirmModal" onClick={this.saveLead}>Save</button>
        <button className="cancel" onClick={this.resetLead}>Cancel</button>
      </section>
    </div>)
  }

  renderSmsOptInModal() {
    return( <div className='updateLeadModal' hidden={this.state.hideSmsOptInModal}>
      <section className='modal-main updateLeadModal__content'>
        <p>Showcase IDX does not offer SMS functionality. If the lead shows an opted in message, you are allowed to send the lead SMS from a 3rd-party CRM. If the lead shows "No SMS Opt In Detected", the lead did not opt into receiving SMS or they were created before this feature was implemented. Visit our <a href="https://support.showcaseidx.com/hc/en-us/articles/360004220292-Privacy-Settings">Support Center</a> for more infromation.</p>
        <button className="cancel" onClick={this.resetLead}>Cancel</button>
      </section>
    </div>)
  }

  renderEditLeadModal() {
    // temp re-use of the className (will refactor)
    return( <div className='updateLeadModal' hidden={this.state.hideEditLeadModal}>
    <section className='modal-main'>
      <h1>Edit Lead</h1>

      <h4>First Name</h4>
      <input type="text" name="first_name" value={this.state.leadFirstName||""} onChange={this.handleChange.bind(this, 'leadFirstName')} />
      <h4>Last Name</h4>
      <input type="text" name="last_name" value={this.state.leadLastName||""} onChange={this.handleChange.bind(this, 'leadLastName')} />
      <h4>Phone</h4>
      <input type="text" name="phone" value={this.state.leadPhone||""} onChange={this.handleChange.bind(this, 'leadPhone')} />
      <h4>Email</h4>
      <input type="text" name="email" value={this.state.leadEmail||""} onChange={this.handleChange.bind(this, 'leadEmail')} />

      <button className="confirmModal" onClick={this.saveLead}>Save</button>
      <button className="cancel" onClick={this.resetLead}>Cancel</button>
    </section>
  </div>)
  }

}



// WEBPACK FOOTER //
// client/components/sections/website/Leads/Details.js